import React, { useState, useEffect } from 'react';

import { CloseOutlined } from '@ant-design/icons';
import { FormFiltros } from './FormFiltros';

import * as S from './styles';

export function Filtros({
  handerFiltrar = () => {},
  isClearFilter = () => {},
  paramsFilter = () => {},
  paginationFilter = () => {},
  loading = false
}) {
  const [filtroAtivo, setFiltroAtivo] = useState(false);
  const [activeKey, setActiveKey] = useState([]);
  const [clearFiltrosAtivos, setClearFiltrosAtivos] = useState(false);

  const updateFilter = value => {
    setFiltroAtivo(value);
    !!value && setClearFiltrosAtivos(false);
  };

  const limparFiltro = e => {
    setClearFiltrosAtivos(true);
    isClearFilter();
    return e.stopPropagation();
  };

  const callback = key => setActiveKey(key);

  useEffect(() => {
    setActiveKey([]);
  }, [handerFiltrar]);

  const extraCollapse = () => (
      <S.ContainerExter>
        <S.DividerExtra type="vertical" />
        <S.TitleExtra>Filtros Ativos</S.TitleExtra>
        <S.DividerExtra type="vertical" />
        <S.TitleExtra color="#D42929" onClick={limparFiltro}>
          <CloseOutlined style={{ marginRight: 8, color: '#D42929' }} />
          Remover Filtros
        </S.TitleExtra>
      </S.ContainerExter>
    );

  return (
    <S.CollapseFiltro onChange={callback} activeKey={activeKey}>
      <S.CollapsePanel
        header="Filtrar Solicitações"
        bordered={false}
        extra={filtroAtivo && extraCollapse()}
        key="1"
        ghost
      >
        <S.ContentFiltro style={{ display: 'contents' }}>
          <FormFiltros
            isFiltroAtivo={updateFilter}
            handlerClear={clearFiltrosAtivos}
            handlerFiltrar={handerFiltrar}
            paramsFilter={paramsFilter}
            paginationFilter={paginationFilter}
            loading={loading}
          />
        </S.ContentFiltro>
      </S.CollapsePanel>
    </S.CollapseFiltro>
  );
}
